import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/mall/activity.vue'
createPage(Page)